import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";

const StarAccessModal = (props) => {
  const history = useHistory();
  return (
    <>
      <Modal show={props.show} onHide={props.starModalCose}>
        <Modal.Body>
          <div className="modal_close">
            <h3>Please upgrade to Star packages to access these benefits.</h3>
            <Button
              variant="secondary"
              onClick={props.starModalCose}
              className="close_buuut"
            ></Button>
          </div>

          <div
            className="monthly_price pb-3"
            style={{ backgroundColor: "blue" }}
          >
            <div className="star_price_inner">
              <div className="price_inner_inner">
                <div className="price_inner_heading">
                  <h3>TVI Star</h3>
                  <h3>$1,997</h3>
                  <p>Yearly</p>
                </div>
              </div>
            </div>
            <div className="star_price_inner">
              <div className="price_inner_inner">
                <div className="price_inner_heading">
                  <h2>TVI Star Experience</h2>
                  <h3>$4,997</h3>
                  <p>Yearly</p>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="footer_but">
          <Button
            variant="secondary"
            onClick={() => {
              history.push(`/my-account?star=1`);
            }}
            className="yesbut"
          >
            Yes
          </Button>
          <Button
            variant="primary"
            onClick={props.starModalCose}
            className="nobut"
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default StarAccessModal;
